
<div class="container-fluid pt-120 pb-4">
    <div class="container">
        <div class="row error-bar bg-red">
            <div class="col-sm-12">
                <h1 class="text-white text-center text-uppercase pt-5">404</h1>
                <p class="text-white text-center pt-4">Ooops! This is not the page you're looking for.</p>
                <p class="text-white text-center pt-2 pb-5">Please try using the navigation in our menu to locate the page you are trying to access.</p>
            </div>
        </div>
    </div>
</div>